<template lang="pug">
  .stars-container
    img.star(v-for='(_, index) in starsToRender'
    :src='index < stars ? starOn : starOff'
    alt='star'
    :class='[size, { pointer: enableEdit }]'
    @click='setStars(index)'
  )
</template>

<script>
import starOn from '../assets/ic_star_on.svg'
import starOff from '../assets/ic_star_off.svg'

export default {
  data() {
    return {
      starsToRender: Array(5).fill(1),
      starOn,
      starOff
    }
  },
  props: {
    stars: Number,
    size: { type: String, required: false, default: 'normal' },
    enableEdit: { type: Boolean, required: false, default: false }
  },
  methods: {
    setStars(index) {
      if (this.enableEdit) this.$emit('setStars', index + 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.stars-container {
  display: flex;
}

.pointer {
  cursor: pointer;
}

.star {
  height: 16px;
  margin-right: 5px;
  width: 16px;

  &.big {
    height: 25px;
    margin-right: 11px;
    width: 25px;
  }

  &.xbig {
    height: 35px;
    margin-right: 20px;
    width: 35px;
  }
}
</style>
